import { current } from "@reduxjs/toolkit";
import axios from "axios"
import { useEffect, useState } from "react";

export default function LatestCallsModule({ baseUrl, client, currentUser, setLatestCallsSeeAll, setSelectedId, setSelectedCustomer }: { baseUrl: string, client: any, currentUser: any, setLatestCallsSeeAll: (check: boolean) => void, setSelectedId: (id: string) => void, setSelectedCustomer: (customer: any) => void }) {
    const [loadingCalls, setLoadingCalls] = useState(true);
    const [calls, setCalls] = useState<any>([{}]);
    const getLatestCalls = async () => {

        try {
            const response = await axios.get(baseUrl + '/getAllCustomerCalls', { params: { client_uid: client?.uid, filter: 'today', token: currentUser?.token } });

            if (response.data.status === "OK") {
                setCalls(response.data.data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoadingCalls(false);
        }
    }

    useEffect(() => {
        if (!client) return;
        getLatestCalls();
    }, [client?.uid, baseUrl, currentUser])

    const handleSeeAllClick = () => {
        setLatestCallsSeeAll(true);
    }

    

    const handleCustomerNameClick = async (customer_id: string) => {
        try {
            setSelectedId(customer_id);
            const response = await axios.get(baseUrl + '/getCustomerById', { params: { token: currentUser?.token, customer_id: customer_id, client_uid: client?.uid } })

            if (response.data.status === "OK") {
                setSelectedCustomer(response.data.data);
            }
        } catch (err) {
            console.error(err);
        }
    }



    return (
        <div className="lg:col-span-2 bg-white rounded-2xl border border-slate-100 p-6 shadow-sm">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-sm font-semibold">Siste samtale</h2>
                <button onClick={() => handleSeeAllClick()} className="text-xs text-indigo-600 hover:underline">Se alle</button>
            </div>

            <div className="w-full overflow-y-auto h-[205px]">
                <table className="w-full text-sm border-separate border-spacing-y-2 overflow-x-auto">
                    <thead>
                        <tr className="text-[11px] text-slate-500">
                            <th className="text-start font-normal pb-1">Kunde</th>
                            <th className="text-center font-normal pb-1">Beløp</th>
                            <th className="text-center font-normal pb-1">Date</th>
                            <th className="text-right font-normal pb-1">Kanal</th>
                            <th className="text-right font-normal pb-1">Status</th>
                        </tr>
                    </thead>
                    <tbody className="text-slate-700">
                        {loadingCalls ? (
                            <tr>
                                <td colSpan={4}>
                                    <div className="flex items-center justify-center h-48 w-full">
                                        <div className="flex flex-col items-center">
                                            <div className="w-12 h-12 border-4 border-purple-400 border-t-transparent rounded-full animate-spin"></div>
                                            <p className="mt-3 text-gray-600 animate-pulse">Laster...</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            <>
                                {
                                    calls.length === 0 && (
                                        <tr>
                                            <td colSpan={4}>
                                                <span className="text-medium">Ingen siste transaksjon</span>
                                            </td>
                                        </tr>
                                    )
                                }
                                {calls.map((t: any, i: number) => (
                                    <tr className="border-b border-slate-100">
                                        <td>
                                            <span className="text-sm text-[11px]"><button type="button" className="underline" onClick={() => handleCustomerNameClick(t.customer_table_id)}>{t.customer_table_name}</button></span>
                                        </td>
                                        <td className="text-center">
                                            <span className="font-medium text-[11px]">{t.charge_price !== null ? t.charge_price : '' + " " + client?.currency}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="font-medium text-[11px]">{t.date + " " + t?.time}</span>
                                        </td>
                                        <td className="text-right">
                                            <span className="text-[11px] bg-slate-100 text-slate-600 px-2 py-0.5 rounded-full">{t.is_video_call === "1" ? 'Video' : 'Audio'}</span>
                                        </td>
                                        <td className="text-right">
                                            <span className="text-[11px] bg-slate-100 text-slate-600 px-2 py-0.5 rounded-full">{t.call_status}</span>
                                        </td>
                                    </tr>
                                ))}
                            </>

                        )}
                    </tbody>
                </table>
            </div>



        </div>
    )
}